export default "__VITE_ASSET__DjA3BAFA__"